/**
 * SpecialistID — Product PDP modular bundle: BILLING/SHIPPING ADDRESS SYNC
 * Part of the custom-product-* set (split out of the legacy custom-product.js).
 *
 * On the custom order form: when the customer selects "same as billing address",
 * copies billing field values to the corresponding shipping fields and hides the
 * shipping section; restores required attributes and shows it when they switch back.
 * Also keeps shipping in sync as billing fields change while "Yes" is selected.
 *
 * No SPID dependency — plain DOM scripting on Jotform field IDs.
 * No public API — self-initialising on DOMContentLoaded.
 *
 * LOAD ORDER: can be loaded at any point; no dependency on other modules.
 */
document.addEventListener('DOMContentLoaded', function() {
    // Field mappings: billing -> shipping
    var fieldMappings = {
        'Field154': 'Field160', // Street Address
        'Field155': 'Field161', // Address Line 2
        'Field156': 'Field162', // City
        'Field157': 'Field163', // State/Province/Region
        'Field158': 'Field164', // Postal/Zip Code
        'Field159': 'Field165'  // Country (select)
    };

    // Cache the shipping address container
    var shippingDiv = document.querySelector('#foli160');
    if (!shippingDiv) return;

    // Handle radio button change
    document.querySelectorAll('input[name="Field479"]').forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.value === 'Yes') {
          // Copy billing values to shipping
          Object.entries(fieldMappings).forEach(([billingId, shippingId]) => {
            const billingField = document.querySelector('#' + billingId);
            const shippingField = document.querySelector('#' + shippingId);
            if (billingField && shippingField) {
              shippingField.value = billingField.value;
            }
          });

          // Hide shipping address div
          shippingDiv.style.display = 'none';

          // Remove required attribute from shipping fields (so form can submit)
          shippingDiv.querySelectorAll('[required]').forEach(field => {
            field.removeAttribute('required');
            field.setAttribute('data-was-required', 'true');
          });

        } else {
          // Show shipping address div
          shippingDiv.style.display = 'block';

          // Restore required attributes
          shippingDiv.querySelectorAll('[data-was-required]').forEach(field => {
            field.setAttribute('required', '');
            field.removeAttribute('data-was-required');
          });
        }
      });
    });

    // Also sync when billing fields change while "Yes" is selected
    Object.entries(fieldMappings).forEach(([billingId, shippingId]) => {
      const billingField = document.querySelector('#' + billingId);
      if (billingField) {
        billingField.addEventListener('input', function() {
          const radioYes = document.querySelector('#Field479_1');
          if (radioYes && radioYes.checked) {
            const shippingField = document.querySelector('#' + shippingId);
            if (shippingField) {
              shippingField.value = this.value;
            }
          }
        });

        billingField.addEventListener('change', function() {
          const radioYes = document.querySelector('#Field479_1');
          if (radioYes && radioYes.checked) {
            const shippingField = document.querySelector('#' + shippingId);
            if (shippingField) {
              shippingField.value = this.value;
            }
          }
        });
      }
    });
});
